module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-6.7460834b.jpg";